var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-search-results"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.searchResults && _vm.searchResults.length === 0)?_c('div',{staticClass:"no-results"},[_vm._t("no-results")],2):_c('div',{staticClass:"search-results"},[_vm._t("result",null,{"result":_vm.searchResults})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }